// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import navigation from './navigation.svg';

interface NavigationIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: NavigationNames;
}

export function NavigationIcon({ name, ...props }: NavigationIconProps) {
  return <Icon {...props} link={navigation} name={name} />
}

type NavigationNames =
  | 'app_settings_alt'
  | 'apps_outage'
  | 'apps'
  | 'arrow_back_ios_new'
  | 'arrow_back_ios'
  | 'arrow_drop_down_circle'
  | 'arrow_forward_ios'
  | 'assistant_direction'
  | 'campaign'
  | 'double_arrow'
  | 'east'
  | 'expand_circle_down'
  | 'first_page'
  | 'fullscreen_exit'
  | 'fullscreen'
  | 'home_work'
  | 'last_page'
  | 'legend_toggle'
  | 'maps_home_work'
  | 'menu_open'
  | 'menu'
  | 'north_east'
  | 'north_west'
  | 'north'
  | 'offline_share'
  | 'payments'
  | 'pivot_table_chart'
  | 'refresh'
  | 'south_east'
  | 'south_west'
  | 'south'
  | 'subdirectory_arrow_left'
  | 'subdirectory_arrow_right'
  | 'switch_left'
  | 'switch_right'
  | 'unfold_less'
  | 'unfold_more'
  | 'waterfall_chart'
  | 'west'
;

